var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('keep-alive',[(_vm.user !== null && _vm.user.roles.includes(_vm.Role.PortalUser))?_c('AppBar'):_vm._e()],1),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }